function processHtml(htmlElement) {
    const allScripts = [];
    htmlElement.childNodes.forEach((node) => {
        if (node.nodeName === 'SCRIPT') {
            if (node.src) {
                // External script
                allScripts.push({ url: node.src });
            }
            else {
                // Inline script
                const content = node.textContent.trim();
                if (content) {
                    allScripts.push({ content });
                }
            }
        }
    });
    return allScripts;
}
export default processHtml;
//# sourceMappingURL=ScriptProcessor.js.map